import { Component } from 'opus-angular-seed-core';

@Component({
    bindings: {
        cancel: '&',
        onUpdate: '&',
        budget: '<'
    },
    template: `
        <div class="modal-header">
            <button type="button" class="close" ng-click="vm.cancel()"></button>
            <h2>{{ 'budget.Add budget rule' | translate }}</h2>
        </div>
        <div class="modal-body">
            <form-wrapper class="form" form="vm.form">
                <form-row ng-if="!vm.budget" error="vm.form.errors.yearPeriod">
                    <label class="label">{{ 'budget.Period' | translate }} *</label>
                    <div class="items">
                        <select ng-model="vm.form.model.yearPeriod" class="form-control">
                            <option>{{ vm.moment().format('YYYY') }}</option>
                            <option>{{ vm.moment().add(1, 'years').format('YYYY') }}</option>
                            <option>{{ vm.moment().add(2, 'years').format('YYYY') }}</option>
                        </select>
                        <ul class="checkboxes">
                            <li><label><input ng-model="vm.form.model.applyToUpcomingYears" type="checkbox"> {{ 'budget.Apply to all upcoming years' | translate }}</label></li>
                        </ul>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                <form-row ng-if="!vm.budget" error="vm.form.errors.type">
                    <label class="label">{{ 'budget.Type' | translate }} *</label>
                    <div class="items">
                        <ul class="checkboxes">
                            <li ng-repeat="(value, label) in vm.BUDGET_ENUM.LABELS">
                                <label>
                                    <input ng-model="vm.form.model.type" value="{{ value }}" type="radio" name="r01"> {{ label }}
                                </label>
                            </li>
                        </ul>
                        <form-row-error></form-row-error>
                    </div>
                </form-row>
                    <div ng-if="vm.form.model.type === vm.BUDGET_ENUM.KEYS.DEPARTMENT && !vm.budget">
                      <form-row error="vm.form.errors.departmentId">
                        <label class="label">{{ 'budget.Department' | translate }}</label>
                        <div class="items">
                          <select class="form-control"
                                  ng-model="vm.form.model.departmentId"
                                  ng-options="department.id as department.value for department in vm.departments track by department.id">
                          </select>
                          <form-row-error></form-row-error>
                        </div>
                      </form-row>
                    </div>
                    <div ng-if="vm.form.model.type === vm.BUDGET_ENUM.KEYS.PERSONAL && !vm.budget">
                      <form-row error="vm.form.errors.userId">
                        <label class="label">{{ 'budget.Employee' | translate }}</label>
                        <div class="items">
                          <select class="form-control"
                                  ng-model="vm.form.model.userId"
                                  ng-options="user.id as user.displayName for user in vm.employees track by user.id">
                          </select>
                          <form-row-error></form-row-error>
                        </div>
                      </form-row>
                    </div>
                    <form-row error="vm.form.errors.budgetSum">
                        <label class="label">
                            {{ 'budget.Budget size' | translate }}
                            <small ng-if="vm.form.model.type === vm.BUDGET_ENUM.KEYS.DEPARTMENT">
                                {{ 'budget.Total' | translate }}
                            </small>
                            <small ng-if="vm.form.model.type === vm.BUDGET_ENUM.KEYS.PERSONAL">
                                {{ 'budget.Per employee' | translate }}
                            </small>
                        </label>
                        <div class="items">
                            <input ng-model="vm.form.model.budgetSum" type="number" min="1" class="form-control">
                            <form-row-error></form-row-error>
                        </div>
                    </form-row>
            </form-wrapper>
        </div>
        <div class="modal-footer">
            <ul class="actions01">
                <li class="primary">
                    <button class="btn main" type="button" ng-click="vm.save()">
                        <span ng-if="vm.budget">{{ 'general.Update' | translate }}</span>
                        <span ng-if="!vm.budget">{{ 'general.Add' | translate }}</span>
                    </button>
                </li>
                <li><button class="btn discrete" type="button" ng-click="vm.cancel()">{{ 'general.Cancel' | translate }}</button></li>
            </ul>
        </div>
    `
})
export default class {
    constructor (moment, lodash, FormFactory, ClassifierBudgetResource, EmployeeBudgetResource, ClassifierResource, UserResource, TokenService,
                 BUDGET_ENUM, CLASSIFIER_ENUM, ROLE_CODE_ENUM, USER_STATUS_ENUM) {
        this.moment = moment;
        this.lodash = lodash;
        this.FormFactory = FormFactory;
        this.ClassifierBudgetResource = ClassifierBudgetResource;
        this.EmployeeBudgetResource = EmployeeBudgetResource;
        this.ClassifierResource = ClassifierResource;
        this.UserResource = UserResource;
        this.TokenService = TokenService;
        this.BUDGET_ENUM = BUDGET_ENUM;
        this.CLASSIFIER_ENUM = CLASSIFIER_ENUM;
        this.ROLE_CODE_ENUM = ROLE_CODE_ENUM;
        this.USER_STATUS_ENUM = USER_STATUS_ENUM;
    }

    $onInit () {
        this.departments = [];
        this.employees = [];
        if (this.budget) {
            if (this.budget.departmentId) {
                this.form = this.FormFactory.createFromResource(new this.ClassifierBudgetResource(this.budget), this.budget);
            }
            else {
                this.form = this.FormFactory.createFromResource(new this.EmployeeBudgetResource(this.budget), this.budget);
            }
        }
        else {
            this.form = this.FormFactory.create(new this.ClassifierBudgetResource(), model => model.$save());
            this.form.model.type = this.BUDGET_ENUM.KEYS.DEPARTMENT;
        }

        if (!this.budget) {
            this.queryDepartments();
            this.queryEmployees();
        }
    }

    queryDepartments () {
        this.ClassifierResource.query({ type: this.CLASSIFIER_ENUM.KEYS.DEPARTMENT }).$promise.then((response) => {
            this.departments = response;
        });
    }

    queryEmployees () {
        const defaultEmployeeFilter = {
            'siteIds[]': this.TokenService.getActiveSiteId(),
            roleCode: this.ROLE_CODE_ENUM.KEYS.EMPLOYEE,
            'statuses[]': [this.USER_STATUS_ENUM.KEYS.ACTIVE, this.USER_STATUS_ENUM.KEYS.NOT_STARTED]
        };

        this.UserResource.query(defaultEmployeeFilter).$promise.then((response) => {
            this.employees = response;
        });
    }

    beforeSave () {
        if (this.form.model.yearPeriod) {
            this.form.model.periodStartDate = `${this.form.model.yearPeriod}-01-01`;
            this.form.model.periodEndDate = `${this.form.model.yearPeriod}-12-31`;
        }

        this.switchResourceIfNeeded();
    }

    switchResourceIfNeeded () {
        if (this.budget) {
            return;
        }
        // this removes resource from form model
        const formModel = this.lodash.assign({}, this.form.model);

        /** In case of create switch resources */
        if (formModel.type === this.BUDGET_ENUM.KEYS.DEPARTMENT) {
            this.form = this.FormFactory.createFromResource(new this.ClassifierBudgetResource(formModel), formModel);
        }
        else if (formModel.type === this.BUDGET_ENUM.KEYS.PERSONAL) {
            this.form = this.FormFactory.createFromResource(new this.EmployeeBudgetResource(formModel), formModel);
        }
    }

    save () {
        this.beforeSave();
        this.form.save()
            .then(() => {
                this.onUpdate();
            });
    }
}



// WEBPACK FOOTER //
// ./src/app/components/modals/user/budget/index.js